import { IOption } from 'components/ui/select'

export default [
  { label: 'Herr', value: 'Herr' },
  { label: 'Frau', value: 'Frau' },
] as IOption[]
